/*jslint browser: true, fudge: true, long: true, this: true */
/*global blacksunplc, encodeURIComponent, self, bsComponents */

/**
 * Tab component
 */
(function () {
    "use strict";

    var arrays = blacksunplc.arrays;                  // import * as arrays from "module:blacksunplc/arrays"
    var classList = blacksunplc.attributes.classList; // import {classList} from "module:blacksunplc/attributes"
    var events = blacksunplc.events;                  // import * as events from "module:blacksunplc/events"
    var classes = blacksunplc.classes;                // import * as classes    from "module:blacksunplc/classes"
    var behaviors = blacksunplc.behaviors;            // import * as behaviors  from "module:blacksunplc/behaviors"
    var objects = blacksunplc.objects;                // import * as objects    from "module:blacksunplc/objects"
    var $$ = blacksunplc.nodes.qsa;                   // import {qsa as $$}   from "module:blacksunplc/nodes"
    var security = blacksunplc.security;              // import * as security from "module:blacksunplc/security"
    var utils = bsComponents.utils;

    var exports = {};

    exports.TablistBehavior = classes.define({
        /**
         * @this {!exports.TablistBehavior}
         * @param {!HTMLUListElement} host
         */
        "constructor": function (host) {
            this.host = host;
            this.host.tablist = host;
        },

        "methods": /** @lends {exports.TablistBehavior.prototype} */{
            /**
             * @override
             * @this {!exports.TablistBehavior}
             */
            "connectedCallback": function () {
                var lexicalThis = this;

                if (this.host.getAttribute("data-type")) {
                    var hash = security.safeLocationHash();
                    if (hash) {
                        hash = hash.replace("#", "");
                        var target = $$("button[aria-controls='" + hash + "']", this.host);
                        lexicalThis.selectTab(target[0]);
                        setTimeout(function () {
                            window.scrollTo({
                                behavior: "smooth",
                                left: 0,
                                top: target[0].offsetTop - 50
                            });
                        }, 100);
                    }
                }

                arrays.forEach($$("button", this.host), function (button) {
                    events.add(button, "click", function (event) {
                        event.preventDefault();
                        lexicalThis.selectTab(button);
                    });
                    events.add(button, "keydown", function (event) {
                        utils.commonKeyDown(event, lexicalThis.host, "button");
                    });
                });
            },

            "selectTab": function (selectedTab) {
                var id = selectedTab.getAttribute("aria-controls");
                var targetTabContent = document.getElementById(id);
                arrays.forEach($$("[role='tab']", this.host), function (tab) {
                    if (tab !== selectedTab && tab.getAttribute("aria-selected") === "true") {
                        var ariaControls = tab.getAttribute("aria-controls");
                        classList(document.getElementById(ariaControls)).remove("selected");
                        classList(tab).remove("selected");
                        tab.setAttribute("aria-selected", false);
                    }
                });

                selectedTab.setAttribute("aria-selected", true);
                classList(targetTabContent).add("selected");
                classList(selectedTab).add("selected");
                if (this.host && this.host.getAttribute("data-type")) {
                    history.pushState(null, "", "#" + id);
                }

            },

            "selectByIndex": function (index) {
                var tab = $$("[role='tab']", this.host)[index];
                if (tab) {
                    this.selectTab(tab);
                }
            }
        }
    });

    exports.selectByIndex = function (index) {
        exports.TablistBehavior.prototype.selectByIndex(index);
    };

    /* jshint ignore:start */

    /** @type {(undefined|!exports.TablistBehavior)} */
    HTMLUListElement.prototype.tablist; // this fails in IE/Edge 7 and below

    /* jshint ignore:end */

    behaviors.define("tablist-ul", exports.TablistBehavior, {"extends": "ul"});

    bsComponents.tablists = objects.freeze(exports);
}());

/* Tab component end here */